import { IconProps } from "./";
import Icon from "./assets/cancel_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon44Cancel(props: IconProps) {
  return <BaseIcon className="text-6xl" icon={<Icon />} {...props} />;
}
